'use client'

import Script from 'next/script'
import { useTermlyConsent } from './useTermlyConsent'

interface ConsentBasedMetaPixelProps {
  pixelId: string
  debug?: boolean
}

export function ConsentBasedMetaPixel({
  pixelId,
  debug = false
}: ConsentBasedMetaPixelProps) {
  const hasConsent = useTermlyConsent(debug)

  if (!hasConsent) {
    return null
  }

  return (
    <>
      <Script
        id="meta-pixel-script"
        data-testid="meta-pixel-script"
        data-category="advertising"
        strategy="afterInteractive"
      >
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', ${JSON.stringify(pixelId)});
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${encodeURIComponent(pixelId)}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  )
}

export default ConsentBasedMetaPixel
